export default __webpack_public_path__ + "static/media/edituser.a50ce525.svg";